module.exports = __webpack_public_path__ + "static/media/EllenRipley.987a4319.jpg";